var CODE128_AUTO = {};
export {
  CODE128_AUTO as __exports
};
//# sourceMappingURL=index192.js.map
